<!-- Full viewport split-flap board demo -->
<div class="h-screen">
  <app-split-flap-board
    [config]="config"
    [messages]="messages"
    [headerText]="'FlippyBoards.com Demo'"
    [footerText]="'Powered by FlippyBoards.com • Sign up to create your own board'"
  />
</div>
